var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeelBetterIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.6514 10.5637C32.8285 10.2837 32.953 9.96978 33.1022 9.67204C33.0255 9.56781 32.9487 9.46358 32.872 9.35935C31.6983 9.78414 30.5352 10.2423 29.3488 10.6274C26.2429 11.6344 23.5837 13.3537 21.3102 15.6693C15.4373 21.6497 12.5849 30.6647 16.4609 38.7701C18.5728 43.1866 21.4969 46.8635 25.8045 49.2152C31.1217 52.1183 36.5432 52.3727 41.9143 49.3078C47.642 46.0393 51.0076 40.8551 53.4513 34.9324C53.5618 34.6644 53.4967 34.3235 53.5219 33.8525C52.1255 34.0457 52.1127 34.0296 50.9597 34.9516C46.2546 38.7118 41.1138 39.4967 35.4675 37.2969C32.5793 36.1717 30.6175 34.1676 29.6313 31.286C27.0913 23.8618 28.5705 17.0084 32.6512 10.5644L32.6514 10.5637Z",
    fill: "#FC7F11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeelBetterIcon2);
export default __webpack_public_path__ + "static/media/feel-better-icon2.6ab28fba3b737250596a38d9f3017668.svg";
export { ForwardRef as ReactComponent };